import React from "react";
import Panel from "muicss/lib/react/panel";
import { EventEmitter } from "fbemitter";
import axios from "axios";
import moment from "moment";
import { Server } from "stellar-sdk";
import Metrics from "./Metrics";
import AppBar from "./AppBar";
import AccountBalance from "./AccountBalance";
import FeeStats from "./FeeStats";
import NetworkStatus from "./NetworkStatus";
import Incidents from "./Incidents";
import LedgerCloseChart from "./LedgerCloseChart";
import LumensCirculating from "./LumensCirculating";
import LumensNonCirculating from "./LumensNonCirculating";
import PublicNetworkLedgersHistoryChart from "./PublicNetworkLedgersHistoryChart";
import RecentOperations from "./RecentOperations";
import TotalCoins from "./TotalCoins";
import TransactionsChart from "./TransactionsChart";
import FailedTransactionsChart from "./FailedTransactionsChart";
import { LIVE_NEW_LEDGER, TEST_NEW_LEDGER } from "../events";
import { setTimeOffset } from "../common/time";
import { ScheduledMaintenance } from "./ScheduledMaintenance";
import { connect } from "react-redux";
import language from "./../dictionary/index";
import {setLanguage , setNetwork} from './../redux/actions/commonAction'
import queryString from 'query-string'
//import 'antd/dist/antd.css'
import {
  TotalIssuedPaymon,
  FounderTeam,
  NewAnchorReserve,
  NewUserReserve,
  MonthlyDistributionReserve,
  RefundPmn,
  TotalDistributedPmn,
  FounderTeamDistributed,
  NewAnchorDistributed,
  NewUserDistributed,
  MonthlyDistributed,
  TotalGold,
} from "./DistributionWidgets";
import { LastDistribution, CurrentInflation } from "./InflationWidgets";
import InflationProgress from "./InflationProgress";
import Nodes from './Nodes';
import Modal from "@material-ui/core/Modal";

//const horizonLive = "https://horizon.stellar.org";
//const horizonTest = "https://horizon-testnet.stellar.org";

const horizonLive = "https://horizon.kuknos.org";
const horizonTest = "https://hz1-test.kuknos.org";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.chrome57 = navigator.userAgent.toLowerCase().indexOf("chrome/57") > -1;
    this.emitter = new EventEmitter();
    this.sleepDetector();

    // Add an axios response interceptor to setup a timestamp offset between
    // local time and horizon time if a date header is present
    // this will be used to settle clock discrepancies
    axios.interceptors.response.use(
      function(response) {
        let headerDate = response.headers.date;
        if (headerDate) {
          setTimeOffset(
            Math.round((new Date() - new Date(response.headers.date)) / 1000),
          );
        }
        return response;
      },
      function(error) {
        return Promise.reject(error);
      },
    );

    // forceTheme is our way to celebrate May, 4th.
    var forceTheme = false;
    var may4 = false;

    var now = new Date();
    var d = now.getDate();
    var m = now.getMonth() + 1;
    var y = now.getFullYear();

    if (d == 4 && m == 5) {
      forceTheme = true;
      may4 = true;
    }

    // TLJ
    if (d == 9 && m == 12 && y == 2017) {
      forceTheme = true;
    }

    // TRS
    if (d == 20 && m == 12 && y == 2019) {
      forceTheme = true;
    }

    // For testing
    if (localStorage.getItem("forceTheme") != null) {
      forceTheme = true;
      may4 = true;
    }

    this.state = { forceTheme, may4, open: false };


    let queryData = queryString.parse(location.search)
    if(queryData.lang == 'en'){
      props.setLanguage("english")
    }
    if(queryData.network == 'test'){
      props.setNetwork("test")
    }
    
  }

  componentDidMount() {
    



    this.streamLedgers(horizonLive, LIVE_NEW_LEDGER);
    this.streamLedgers(horizonTest, TEST_NEW_LEDGER);

    //this.getStatusPageData();
    this.statusPageUpdateInterval = setInterval(
      () => this.getStatusPageData(),
      30 * 1000,
    );
  }

  componentWillUnmount() {
    clearInterval(this.statusPageUpdateInterval);
  }

  getStatusPageData() {
    axios
      .get("https://9sl3dhr1twv1.statuspage.io/api/v2/summary.json")
      .then((response) => {
        this.setState({ statusPage: response.data });
      });
  }

  reloadOnConnection() {
    return axios
      .get("https://s3-us-west-1.amazonaws.com/stellar-heartbeat/index.html", {
        timeout: 5 * 1000,
      })
      .then(() => location.reload())
      //.catch(() => {setTimeout(this.reloadOnConnection.bind(this), 1000));}
  }

  sleepDetector() {
    if (!this.lastTime) {
      this.lastTime = new Date();
    }

    let currentTime = new Date();
    if (currentTime - this.lastTime > 10 * 60 * 1000) {
      this.setState({ sleeping: true });
      //this.reloadOnConnection();
      return;
    }

    this.lastTime = new Date();
    setTimeout(this.sleepDetector.bind(this), 5000);
  }

  streamLedgers(horizonURL, eventName) {
    // Get last ledger
    axios.get(`${horizonURL}/ledgers?order=desc&limit=1`).then((response) => {
      let lastLedger = response.data._embedded.records[0];

      new Server(horizonURL)
        .ledgers()
        .cursor(lastLedger.paging_token)
        .limit(200)
        .stream({
          onmessage: (ledger) => this.emitter.emit(eventName, ledger),
        });
    });
  }

  turnOffForceTheme() {
    this.setState({ forceTheme: false });
    return false;
  }

  openGoldModal() {
    this.setState({ open: true });
  }
  closeGoldModal() {
    this.setState({ open: false });
  }

  render() {
    return (
      <div id="main" className={this.state.forceTheme ? "force" : null}>
        <AppBar
          forceTheme={this.state.forceTheme}
          turnOffForceTheme={this.turnOffForceTheme.bind(this)}
        />



        
        <div id="main" className="mui-container-fluid">
          {this.props.network == "live" ? (
            <section>
              <h1 style={{ fontSize: "2em" }}>
                {language.networkStatusLive[this.props.language]}
              </h1>
              <br />
              <div className="row">
                <div className="mui-col-md-4">
                  <NetworkStatus
                    network={language.kuknoslive[this.props.language]}
                    horizonURL={horizonLive}
                    newLedgerEventName={LIVE_NEW_LEDGER}
                    emitter={this.emitter}
                  />
                  {/* <Incidents /> */}
                  <FeeStats horizonURL={horizonLive} />
                  <RecentOperations
                    limit="20"
                    label={language.kuknoslive[this.props.language]}
                    horizonURL={horizonLive}
                    emitter={this.emitter}
                  />
                </div>
                <div className="mui-col-md-8">
                  <LedgerCloseChart
                    network={language.kuknoslive[this.props.language]}
                    horizonURL={horizonLive}
                    limit="200"
                    newLedgerEventName={LIVE_NEW_LEDGER}
                    emitter={this.emitter}
                  />
                  <TransactionsChart
                    network={language.kuknoslive[this.props.language]}
                    horizonURL={horizonLive}
                    limit="200"
                    newLedgerEventName={LIVE_NEW_LEDGER}
                    emitter={this.emitter}
                  />
                  <FailedTransactionsChart
                    network={language.kuknoslive[this.props.language]}
                    horizonURL={horizonLive}
                    limit="200"
                    newLedgerEventName={LIVE_NEW_LEDGER}
                    emitter={this.emitter}
                  />
                  <PublicNetworkLedgersHistoryChart
                    network={language.kuknoslive[this.props.language]}
                    horizonURL={horizonLive}
                    limit="200"
                    newLedgerEventName={LIVE_NEW_LEDGER}
                    emitter={this.emitter}
                  />

                  <Metrics
                    lang={this.props.language}
                    dictionary={language}
                    network={language.kuknoslive[this.props.language]}
                    horizonURL={horizonLive}
                    limit="200"
                    newLedgerEventName={LIVE_NEW_LEDGER}
                    emitter={this.emitter}
                  />
                </div>
              </div>
            </section>
          ) : (
            ""
          )}

          {this.props.network == "live" ? (
            <section>
              <h1 style={{ fontSize: "2em" }}>
                {language.paymonDist[this.props.language]}
              </h1>
              <br />
              <div
                className="mui-col-md-4"
                style={{
                  textAlign:
                    this.props.language == "persian" ? "right" : "left",
                }}
              >
                <TotalIssuedPaymon
                  lang={this.props.language}
                  dictionary={language}
                  horizonURL={horizonLive}
                />
              </div>
              <div
                className="mui-col-md-4"
                style={{
                  textAlign:
                    this.props.language == "persian" ? "right" : "left",
                }}
              >
                <FounderTeam
                  lang={this.props.language}
                  dictionary={language}
                  horizonURL={horizonLive}
                />
              </div>
              <div
                className="mui-col-md-4"
                style={{
                  textAlign:
                    this.props.language == "persian" ? "right" : "left",
                }}
              >
                <NewAnchorReserve
                  lang={this.props.language}
                  dictionary={language}
                  horizonURL={horizonLive}
                />
              </div>
              <div
                className="mui-col-md-4"
                style={{
                  textAlign:
                    this.props.language == "persian" ? "right" : "left",
                }}
              >
                <NewUserReserve
                  lang={this.props.language}
                  dictionary={language}
                  horizonURL={horizonLive}
                />
              </div>
              <div
                className="mui-col-md-4"
                style={{
                  textAlign:
                    this.props.language == "persian" ? "right" : "left",
                }}
              >
                <MonthlyDistributionReserve
                  lang={this.props.language}
                  dictionary={language}
                  horizonURL={horizonLive}
                />
              </div>
              <div
                className="mui-col-md-4"
                style={{
                  textAlign:
                    this.props.language == "persian" ? "right" : "left",
                }}
              >
                <TotalDistributedPmn
                  lang={this.props.language}
                  dictionary={language}
                  horizonURL={horizonLive}
                />
              </div>
              <div
                className="mui-col-md-4"
                style={{
                  textAlign:
                    this.props.language == "persian" ? "right" : "left",
                }}
              >
                <FounderTeamDistributed
                  lang={this.props.language}
                  dictionary={language}
                  horizonURL={horizonLive}
                />
              </div>
              <div
                className="mui-col-md-4"
                style={{
                  textAlign:
                    this.props.language == "persian" ? "right" : "left",
                }}
              >
                <NewAnchorDistributed
                  lang={this.props.language}
                  dictionary={language}
                  horizonURL={horizonLive}
                />
              </div>
              <div
                className="mui-col-md-4"
                style={{
                  textAlign:
                    this.props.language == "persian" ? "right" : "left",
                }}
              >
                <NewUserDistributed
                  lang={this.props.language}
                  dictionary={language}
                  horizonURL={horizonLive}
                />
              </div>
              <div
                className="mui-col-md-4"
                style={{
                  textAlign:
                    this.props.language == "persian" ? "right" : "left",
                }}
              >
                <MonthlyDistributed
                  lang={this.props.language}
                  dictionary={language}
                  horizonURL={horizonLive}
                />
              </div>
              <div
                className="mui-col-md-4"
                style={{
                  textAlign:
                    this.props.language == "persian" ? "right" : "left",
                }}
              >
                <RefundPmn
                  lang={this.props.language}
                  dictionary={language}
                  horizonURL={horizonLive}
                />
              </div>
              <div
                className="mui-col-md-4"
                style={{
                  textAlign:
                    this.props.language == "persian" ? "right" : "left",
                }}
              >
                <div
                  onClick={() => this.openGoldModal()}
                  className={"mouseOver"}
                >
                  <TotalGold
                    lang={this.props.language}
                    dictionary={language}
                    horizonURL={horizonLive}
                  />
                </div>
              </div>
            </section>
          ) : (
            ""
          )}

          {/* {this.props.network == "live" ? (
            <section>
              <h1 style={{ fontSize: "2em" }}>
                {language.inflationProgress[this.props.language]}
              </h1>
              <br />
              <div
                className="mui-col-md-4"
                style={{
                  textAlign:
                    this.props.language == "persian" ? "right" : "left",
                  direction: this.props.language == "persian" ? "rtl" : "ltr",
                }}
              >
                <LastDistribution
                  lang={this.props.language}
                  dictionary={language}
                  horizonURL={horizonLive}
                />
              </div>
              <div
                className="mui-col-md-4"
                style={{
                  textAlign:
                    this.props.language == "persian" ? "right" : "left",
                  direction: this.props.language == "persian" ? "rtl" : "ltr",
                }}
              >
                <CurrentInflation
                  lang={this.props.language}
                  dictionary={language}
                  horizonURL={horizonLive}
                />
              </div>
              <div
                className="mui-col-md-4"
                style={{
                  textAlign:
                    this.props.language == "persian" ? "right" : "left",
                  direction: this.props.language == "persian" ? "rtl" : "ltr",
                }}
              >
                <InflationProgress
                  lang={this.props.language}
                  dictionary={language}
                  horizonURL={horizonLive}
                />
              </div>
            </section>
          ) : (
            ""
          )} */}

          {this.props.network == "test" ? (
            <section>
              <h1 style={{ fontSize: "2em" }}>
                {language.networkStatusTest[this.props.language]}
              </h1>
              <br />
              <div className="mui-col-md-4">
                <NetworkStatus
                  network={language.kuknoslive[this.props.language]}
                  horizonURL={horizonTest}
                  newLedgerEventName={TEST_NEW_LEDGER}
                  emitter={this.emitter}
                />
                <RecentOperations
                  limit="20"
                  label={language.kuknostest[this.props.language]}
                  horizonURL={horizonTest}
                  emitter={this.emitter}
                />
              </div>
              <div className="mui-col-md-8">
                <LedgerCloseChart
                  network={language.kuknostest[this.props.language]}
                  horizonURL={horizonTest}
                  limit="200"
                  newLedgerEventName={TEST_NEW_LEDGER}
                  emitter={this.emitter}
                />
                <TransactionsChart
                  network={language.kuknostest[this.props.language]}
                  horizonURL={horizonTest}
                  limit="200"
                  newLedgerEventName={TEST_NEW_LEDGER}
                  emitter={this.emitter}
                />
                <FailedTransactionsChart
                  network={language.kuknostest[this.props.language]}
                  horizonURL={horizonTest}
                  limit="200"
                  newLedgerEventName={TEST_NEW_LEDGER}
                  emitter={this.emitter}
                />

                <PublicNetworkLedgersHistoryChart
                  network={language.kuknostest[this.props.language]}
                  horizonURL={horizonTest}
                  limit="200"
                  newLedgerEventName={TEST_NEW_LEDGER}
                  emitter={this.emitter}
                />

                <Metrics
                  lang={this.props.language}
                  dictionary={language}
                  network={language.kuknostest[this.props.language]}
                  horizonURL={horizonTest}
                  limit="200"
                  newLedgerEventName={TEST_NEW_LEDGER}
                  emitter={this.emitter}
                />
              </div>
            </section>
          ) : (
            ""
          )}
          

          <section className="mui-row yellowSection"  >
              {this.props.network=='test'?
                <h1 style={{ fontSize: "2em" }} >{language['featuredNodes'][this.props.language]} {language['kuknostest'][this.props.language]} </h1>:
                <h1 style={{ fontSize: "2em" }} >{language['featuredNodes'][this.props.language]} {language['kuknoslive'][this.props.language]} </h1>
              }
              <Nodes
                lang={this.props.language}
                dictionary={language}
                horizonURL={horizonLive}
              />
          </section>



        </div>

        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
        >
          <div id="GoldModal">
            <div className="d-flex justify-content-center">
              <h3
                className="blueColor mouseOver"
                onClick={() => this.closeGoldModal()}
              >
                {language["backToDashboard"][this.props.language]}
              </h3>
            </div>

            <div className="d-flex justify-content-around">
              <h3 className="blackColor">
                {language["today"][this.props.language]}: {this.state.datemonth}
                /{this.state.dateday}/{this.state.dateyear}
              </h3>
              <h3 className="blackColor">
                {language["totalCollateralGold"][this.props.language]} : 20{" "}
                {language["kilogram"][this.props.language]}
              </h3>
            </div>

            <table className="table table-striped">
              <thead>
                <tr>
                  <th>{language["anchor"][this.props.language]}</th>
                  <th>{language["distributedPmn"][this.props.language]}</th>
                  <th>{language["refundedPmn"][this.props.language]}</th>
                  <th>{language["collateralGold"][this.props.language]}</th>
                  <th>{language["certificate"][this.props.language]}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Kuknos</td>
                  <td>6,700,000</td>
                  <td>-</td>
                  <td>6.7kg</td>
                  <td>
                    <a href="../../public/certificate/kuknos.pdf">
                      {language["download"][this.props.language]}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>Tosan</td>
                  <td>5,000,000</td>
                  <td>-</td>
                  <td>5kg</td>
                  <td>
                    <a href="../../public/certificate/tosan.pdf">
                      {language["download"][this.props.language]}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>Sadad</td>
                  <td>3,300,000</td>
                  <td>-</td>
                  <td>3.3kg</td>
                  <td>
                    <a href="../../public/certificate/sadad.pdf">
                      {language["download"][this.props.language]}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>Parsian</td>
                  <td>1,000,000</td>
                  <td>-</td>
                  <td>1kg</td>
                  <td>
                    <a href="../../public/certificate/parsian.pdf">
                      {language["download"][this.props.language]}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>Fanap</td>
                  <td>1,000,000</td>
                  <td>-</td>
                  <td>1kg</td>
                  <td>
                    <a href="../../public/certificate/fanap.pdf">
                      {language["download"][this.props.language]}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>Behsazan</td>
                  <td>1,000,000</td>
                  <td>-</td>
                  <td>1kg</td>
                  <td>
                    <a href="../../public/certificate/behsazan.pdf">
                      {language["download"][this.props.language]}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>Bazargangostar</td>
                  <td>1,000,000</td>
                  <td>-</td>
                  <td>1kg</td>
                  <td>
                    <a href="../../public/certificate/bazargangostar.pdf">
                      {language["download"][this.props.language]}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>Sepehrnet</td>
                  <td>1,000,000</td>
                  <td>-</td>
                  <td>1kg</td>
                  <td>
                    <a href="../../public/certificate/sepehrnet.pdf">
                      {language["download"][this.props.language]}
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = ({ CommonReducer }) => {
  return {
    language: CommonReducer.language,
    network: CommonReducer.network,
  };
};

export default connect(mapStateToProps , {setLanguage , setNetwork})(App);



// WEBPACK FOOTER //
// ./frontend/components/App.js